import React, { useRef, useEffect, useState } from 'react';
//import React, {useEffect } from 'react';
import { SwitchTransition, Transition } from 'react-transition-group';
import { useLocation } from 'react-router-dom';
import { gsap } from 'gsap';
import { SplitText } from "gsap/SplitText";
import { ScrollTo } from "gsap/ScrollToPlugin";
import { ScrollToPlugin } from '../js/ScrollToPlugin.min.js';
import { ScrollSmoother} from "../js/ScrollSmoother.min.js";
import {ScrollTrigger} from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);



gsap.registerPlugin(SplitText, ScrollSmoother ,ScrollToPlugin);
// Define objects

 let tl_heading = gsap.timeline({});

const TransitionComponent = ({ children }) => {

 // window.scrollTo(0, 0);
  const location = useLocation();
    return (
      <SwitchTransition>
        <Transition
        key={location.pathname}
        timeout={500}
        onEnter={(node) => {

          let pageID = node.getAttribute('data-page-id');
          let pageIDClass = document.querySelector('.page-content');
          let mainbg = document.querySelector("#smooth-content");  

          // H1 HEADING TAG ANIMATION
           // Note this is in transitions.js and app.js both are modidifed copies of code
          let tlh1text = gsap.timeline({});
          
          // Preset
          gsap.set(".page-h1 h1", {x:"50px", autoAlpha: 0});
          gsap.set(".hero-text strong", {y:"50px", autoAlpha: 0});
          gsap.set(".h1-accent", {width:"0px"});

          // Animation
          tlh1text.to(".page-h1 h1", {x: "0px", autoAlpha:1, duration: 1, ease: "power4.out", onStart:herotxtfx})
          .to(".h1-accent", {width: "140px", duration: 1, ease: "power4.out",  })
          .to(".hero-text strong", {y:"0px", autoAlpha:1, duration: 1, ease: "power4.out", delay:-0.5,  });
      

          

     // SpliText FX
     let splitTitle = new SplitText(".page-h1 h1", {
      type: "words,chars"
    });
    let chars = splitTitle.chars; //an array of all the divs that wrap each character

    gsap.set(chars, { opacity: 0, y: 10 });
  
    function herotxtfx() {
      gsap.to(chars, {
        duration: 0.2,
        opacity: 1,
        y: 0,
        ease: "none",
        delay:1,
        stagger: {
          each: 0.05,
          from: "random"
        }
      });
    }







   





  

// XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
// ANIMATE HERO
// XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX

// ANIMATION - TRANSITTION SPLASH MASK
// -------------------------------------//
 // Preset it
 gsap.set("#dotmask" ,{scale:0});
 gsap.set("#hoopmask" ,{scale:0});
 
var tl_hero_trans = gsap.timeline({});
tl_hero_trans.to("#hoopmask", {scale:1, duration: 1.5, ease: "power4.out", delay:0.75})
.to("#dotmask", {scale:1, duration: 1.5, ease: "power4.out", delay:-1.75});


// ANIMATION - TRANSITTION SPLASH DOT - used to change the color, this is shown first.
// -------------------------------------//
var tl_bg_trans = gsap.timeline({});

// ====================================== //
// REST TO TOP OF PAGE
// ====================================== //
// rest to top for semaless transition since a SPA
     if (typeof sScroll !== 'undefined') {
      sScroll.scrollTo(0, false); 
    }else {
      window.scrollTo(0, 0);
    }


if (pageID == 'home'){
    // Preset
    gsap.set(".site-footer", {autoAlpha:1, overwrite: true}); // ()< Bug fix! need to add - overwrite: true since exit animation lingeres.
    pageIDClass.classList.remove("bg-home-fill");
    tl_bg_trans.to('.home-transition-curtain', { left:"-1000px", top:"-1000px", transformOrigin:"top top", duration: 3.5, ease: "power4.out"})
    .to(this, {duration: 1, delay:"-2.5", onComplete:addBGfill});
}



if (pageID == 'portfolio'){
     // Preset
     gsap.set(".site-footer", {autoAlpha:1, overwrite: true});
    pageIDClass.classList.remove("bg-portfolio-fill");
    tl_bg_trans.to('.portfolio-transition-curtain', { left:"-1000px", top:"-1000px", transformOrigin:"top top", duration: 3.5, ease: "power4.out"})
    .to(this, {duration: 1, delay:"-2.5", onComplete:addBGfill});
}

if (pageID == 'services'){
     // Preset
     gsap.set(".site-footer", {autoAlpha:1, overwrite: true});
    pageIDClass.classList.remove("bg-services-fill");
    tl_bg_trans.to('.services-transition-curtain', { left:"-1000px", top:"-1000px", transformOrigin:"top top", duration: 3.5, ease: "power4.out"})
    .to(this, {duration: 1, delay:"-2.5", onComplete:addBGfill});
}

if (pageID == 'profile'){
     // Preset
     gsap.set(".site-footer", {autoAlpha:1, overwrite: true});
    pageIDClass.classList.remove("bg-profile-fill");
    tl_bg_trans.to('.profile-transition-curtain', { left:"-1000px", top:"-1000px", transformOrigin:"top top", duration: 3.5, ease: "power4.out"})
    .to(this, {duration: 1, delay:"-2.5", onComplete:addBGfill});
}

if (pageID == 'contact'){
     // Preset
     gsap.set(".site-footer", {autoAlpha:1, overwrite: true});
    pageIDClass.classList.remove("bg-contact-fill");
    tl_bg_trans.to('.contact-transition-curtain', { left:"-1000px", top:"-1000px", transformOrigin:"top top", duration: 3.5, ease: "power4.out"})
    .to(this, {duration: 1, delay:"-2.5", onComplete:addBGfill});
}

if (pageID == 'archive'){
  // Preset
  gsap.set(".site-footer", {autoAlpha:1, overwrite: true});
 pageIDClass.classList.remove("bg-archive-fill");
 tl_bg_trans.to('.archive-transition-curtain', { left:"-1000px", top:"-1000px", transformOrigin:"top top", duration: 3.5, ease: "power4.out"})
 .to(this, {duration: 1, delay:"-2.5", onComplete:addBGfill});
}

if (pageID == 'portfolio-details'){
  gsap.set(".site-footer", {autoAlpha:1, overwrite: true});
}



      // adds colored background 
function addBGfill(){
     // Remove all classes from element.
     mainbg.className = '';
     // add the fill color
     mainbg.classList.add("bg-"+pageID+"-fill");
    // hide the transition SVG
   document.querySelector("."+pageID+"-transition-curtain").style.display="none";
     // XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
     // ON ENTERED - for sycing animation on landing pages, home, contact... - let the inital animations start to play when all is done!
    // 🔔 ALERT THE EXACT SECOND ADDLBGFILL RUNS: - this is also in APP.JS!!!!!
     window.dispatchEvent(new CustomEvent('masterTransitionDone', { detail: { pageID } }));

     // ✅ RE-ENABLE & REFRESH SCROLLTRIGGER HERE: - FIXES BUG <<<<<<<<<<<<<<<<<<<++++++++++++++++++++++++++++++++ !!!!!!!!!
    // Now that the transition curtain is hidden and listeners are ready to catch 'masterTransitionDone',
   // Safe execution check:
    if (typeof ScrollTrigger !== 'undefined') {
      ScrollTrigger.getAll().forEach(st => st.enable());
      ScrollTrigger.refresh();
    } else if (window.gsap?.plugins?.ScrollTrigger) {
      // Fallback if imported via script tags / window object
      window.ScrollTrigger.getAll().forEach(st => st.enable());
      window.ScrollTrigger.refresh();
    }
 }


 }} // END!










        // ==============================================
        // ON EXIT
        // ==============================================
        onExit={(node) => {

          // Animate Out
          // --------------//
          gsap.set(node, {zIndex:1 });
          // 1) ANIMATE - fade out h1 tag and the enitre page of content and footer. 
          tl_heading.to(".page-h1", {x: "-50px", duration: 1, autoAlpha: 0, ease: "power4.out"})
        .to(".page-content", {duration: 0.75, autoAlpha: 0, ease: "power4.out", delay:-1 })
        .to(".site-footer", {duration: 0.5, autoAlpha: 0, ease: "power4.out", delay:-1 }); // need to set opacity to 1 at transitoning back in.
             
        
    

        }}>
        {children}
      </Transition>
    </SwitchTransition>
  );
};

export default TransitionComponent;
